import { ContentDelete } from '@fs/zion-icon'
import { IconButton, useOverlay, DangerButton } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import DeleteGroupUserDialogOverlay from '../dialogOverlays/DeleteGroupUserDialogOverlay'

export default function DeleteGroupUserButton({ memberSummaries, refreshUserGroupsDataAndControls, single }) {
  const overlay = useOverlay()
  const { t } = useTranslation()

  return (
    <>
      <DeleteGroupUserDialogOverlay
        memberSummaries={memberSummaries}
        refreshUserGroupsDataAndControls={refreshUserGroupsDataAndControls}
        {...overlay}
      />
      {single ? (
        <IconButton id="Delete Group icon button" Icon={ContentDelete} color="red" onClick={overlay.handleClick} />
      ) : (
        <DangerButton id="Delete Group button" Icon={ContentDelete} onClick={overlay.handleClick}>
          {t('action.delete', 'Delete')}
        </DangerButton>
      )}
    </>
  )
}
